import 'core-js/stable'
import 'regenerator-runtime/runtime'

import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './app'
import { Provider } from 'react-redux'
import { store } from './store'

declare global {
    interface Window {
        wpSettings: any
    }
}
window.wpSettings = window.wpSettings || {}

const container = document.getElementById('product-builder-app')
if (container) {
    const productId = container.getAttribute('data-product-id') || new URLSearchParams(window.location.search).get('product-id')
    store.dispatch({ type: 'PRODUCT_BUILDER_PRODUCT_LOAD', params: { productId } })

    ReactDOM.render(
        <Provider store={store}>
            <App />
        </Provider>,
        container
    )
}